// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#team-content .btn-delete, #team-content .btn-check {
    padding-right: 8px;
    padding-left: 8px;
}
#team-content .btn-view-calendar .material-icons {
    color: #000;
    margin-left: 8px;
    font-size: 21px;
    line-height: 38px;
}
#team-content .btn-view-calendar {
    float: right;
    margin-left: 5px;
    font-size: 13px;
    text-transform: none;
    padding-left: 5px;
    padding-right: 5px;
}
#team-content .btn-export .material-icons {
    color: #000;
    margin-left: 8px;
    font-size: 20px;
    line-height: 38px;
}
#team-content .btn-export {
    float: right;
    margin-left: 5px;
    font-size: 13px;
    text-transform: none;
    padding-left: 5px;
    padding-right: 5px;
}
#team-content .image-circle i {
    font-size: 36px;
    margin-left: 0px;
}
#modal-team-edit .modal-content-outer {
    height: calc(100% - 0px);
    bottom: 0;
}
#modal-team-edit .modal-content {
    padding: 0px;
}
.textcolor-green {
    color: #26a69a;
}
#modal-content-bottom .team-sub .date {
    color: #905c5c;
}
#modal-content-bottom .team-sub .days {
    color: #905c5c;
}
#modal-content-bottom .team-sub .name {
    color: #26a69a;
}
#modal-content-bottom .team-sub {
    font-size: 13px;
}
#modal-content-bottom .title {
    font-weight: 600;
}
#modal-content-bottom {
    padding: 0px;
    border-top: 2px dashed #ddd;
    padding-top: 15px;
}
#btn-cancel {
    float: right;
    margin-left: 12px;
    color: red;
    font-size: 14px;
    text-transform: none;
    height: 33px;
    line-height: 32px;
    border-radius: 16px;
    width: 90px;
}
#btn-approve {
    float: right;
    font-size: 14px;
    text-transform: none;
    height: 33px;
    line-height: 32px;
    border-radius: 16px;
    width: 90px;
    background-color: #2ec6b7;
}
#modal-content-right .modal-error-text {
    height: auto;
    line-height: normal;
    font-size: 14px;
    margin-bottom: 10px;
    font-weight: normal;
}
#modal-content-right #content-right-btn {
    padding: 0px;
}
#modal-content-right textarea.materialize-textarea:focus:not([readonly]) {
    box-shadow: 0 0px 0 0 #26a69a;
}
#modal-content-right textarea.materialize-textarea {
    box-shadow: 0 0px 0 0 #26a69a;
    color: #905c5c;
}
#modal-content-right .input-field {
    padding: 10px 0px;
    padding-bottom: 0px;
}
#modal-content-right .helper-text {
    display: none;
}
#modal-content-right #inp-req-note {
    font-size: 14px;
    border: 2px solid #aaa4a4;
    padding: 8px 10px;
    min-height: 120px;
    max-height: 120px;
    overflow: auto;
}
#modal-content-right .textcolor {
    color: #000;
}
#modal-content-right #sub-box-balance .textcolor {
    color: #728431 !important;
}
#modal-content-right .text-hour {
    display: block;
    font-size: 11px;
    margin-top: 0px;
    height: 15px;
}
#modal-content-right .text-day {
    display: block;
    font-size: 18px;
    font-weight: bold;
}
#modal-content-right .title {
    display: block;
    font-weight: 600;
}
#modal-content-right .sub-box {
    padding: 12px 0;
    text-align: center;
    border-radius: 12px;
    margin: 0;
    background-color: #F2F0D5;
    width: 100%;
}
#team-content .th-view, #team-content .th-change {
    max-width: 70px;
}
#team-content .th-status {
    max-width: 100px;
    min-width: 100px;
}
#team-content #main-content {
    padding-top: 0px;
}
#team-content #top-content {
    border-bottom: 0px dashed #ece7e7;
}
#team-content #main-btn {
    border-bottom: 2px dashed #ece7e7;
    padding-bottom: 18px;
}
#table-leave-summary .text-left,
.table-leave .text-left {
    text-align: left;
}
#team-content .td-photo {
    height: 65px;
    position: relative;
    min-width: 56px;
}
#team-content .image-circle {
    width: 56px;
    height: 56px;
    position: absolute;
    top: 4px;
    left: 50%;
    margin-left: -28px;
}
#team-content .select-helper-text {
    margin-top: -10px;
}
#team-content #form-filter-request {
    padding: 0 20px;
}
#btn-clear {
    float: right;
    color: #000;
    margin-left: 15px;
}
#btn-search {
    float: right;
    background-color: #1565c0;
}
#team-content #btn-select-limit-row .input-field {
    margin-bottom: 0px;
}
#team-content .input-field {
    margin-top: 0px;
    margin-bottom: 1rem;
}
#team-content .select-wrapper .caret {
    fill: #27766f;
}
#team-content .filter-input-field.select .col {
    border: 2px solid #2b988e;
    border-radius: 11px;
}
#team-content .dropdown-content li {
    min-height: auto;
}
#team-content .dropdown-content li>a, #team-content .dropdown-content li>span {
    line-height: 20px;
    padding: 10px 16px;
}
#team-content .input-field>label, #team-content .input-field>input[type=date]:not(.browser-default)+label {
    color: #27766f;
}
#team-content input[type=text]:not(.browser-default), #team-content input[type=date]:not(.browser-default) {
    font-size: 14px;
    border-bottom: 2px solid #2b988e !important;
    color: #26a69a;
}
#team-content [type="checkbox"]+span:not(.lever) {
    height: 22px;
    line-height: 22px;
    font-size: 14px;
}
#team-content .select-wrapper input.select-dropdown {
    font-size: 14px;
    border-bottom: 0px solid red !important;
    margin-bottom: 0px;
    color: #26a69a;
}
#team-content .grid-container, #team-content .filter-inputs {
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    grid-gap: 10px;
}

/* --- PILL TABS (manual buttons) --- */
.pill-tabs { display:flex; gap:12px; align-items:center; }
.pill-tab {
  appearance: none;
  border: 0;
  background: transparent;
  padding: 12px 24px;          /* ↑ ขยายให้ใหญ่ขึ้น */
  border-radius: 6px;
  font-weight: 600;
  font-size: 16px;             /* ↑ ปรับขนาดฟอนต์ */
  color: #111;
  cursor: pointer;
  line-height: 1.1;
}
.pill-tab:hover { background: #f6f6f6; }
.pill-tab:focus { outline: none; box-shadow: 0 0 0 2px rgba(0,0,0,.05); }
.pill-tab.active {
  background: #efefef;         /* เทาอ่อนตอน active */
  color: #111;
  font-weight: 700;
}
@media (max-width: 480px) {
  .pill-tab { font-size: 16px; padding: 10px 18px; border-radius: 10px; }
}

/* แถวหัว: Tabs + ปุ่มด้านขวา ให้อยู่บรรทัดเดียว */
.tabs-actions-row {
  display:flex; align-items:center; justify-content:space-between;
  gap:16px; flex-wrap:wrap; margin-bottom:15px;
}




`, "",{"version":3,"sources":["webpack://./src/components/Team/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;AACf;AACA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;AAC7B;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,6BAA6B;IAC7B,cAAc;AAClB;AACA;IACI,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,WAAW;AACf;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,YAAY;AAChB;AACA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iCAAiC;AACrC;AACA;IACI,iCAAiC;IACjC,oBAAoB;AACxB;AACA;;IAEI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;AACnB;AACA;IACI,YAAY;IACZ,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,2CAA2C;IAC3C,cAAc;AAClB;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,eAAe;IACf,uCAAuC;IACvC,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,aAAa;IACb,+CAA+C;IAC/C,cAAc;AAClB;;AAEA,uCAAuC;AACvC,aAAa,YAAY,EAAE,QAAQ,EAAE,kBAAkB,EAAE;AACzD;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,kBAAkB,WAAW,sBAAsB;EACnD,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,cAAc,oBAAoB;EACjD,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;AACA,kBAAkB,mBAAmB,EAAE;AACvC,kBAAkB,aAAa,EAAE,qCAAqC,EAAE;AACxE;EACE,mBAAmB,UAAU,sBAAsB;EACnD,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,YAAY,eAAe,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACxE;;AAEA,kDAAkD;AAClD;EACE,YAAY,EAAE,kBAAkB,EAAE,6BAA6B;EAC/D,QAAQ,EAAE,cAAc,EAAE,kBAAkB;AAC9C","sourcesContent":["#team-content .btn-delete, #team-content .btn-check {\r\n    padding-right: 8px;\r\n    padding-left: 8px;\r\n}\r\n#team-content .btn-view-calendar .material-icons {\r\n    color: #000;\r\n    margin-left: 8px;\r\n    font-size: 21px;\r\n    line-height: 38px;\r\n}\r\n#team-content .btn-view-calendar {\r\n    float: right;\r\n    margin-left: 5px;\r\n    font-size: 13px;\r\n    text-transform: none;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n}\r\n#team-content .btn-export .material-icons {\r\n    color: #000;\r\n    margin-left: 8px;\r\n    font-size: 20px;\r\n    line-height: 38px;\r\n}\r\n#team-content .btn-export {\r\n    float: right;\r\n    margin-left: 5px;\r\n    font-size: 13px;\r\n    text-transform: none;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n}\r\n#team-content .image-circle i {\r\n    font-size: 36px;\r\n    margin-left: 0px;\r\n}\r\n#modal-team-edit .modal-content-outer {\r\n    height: calc(100% - 0px);\r\n    bottom: 0;\r\n}\r\n#modal-team-edit .modal-content {\r\n    padding: 0px;\r\n}\r\n.textcolor-green {\r\n    color: #26a69a;\r\n}\r\n#modal-content-bottom .team-sub .date {\r\n    color: #905c5c;\r\n}\r\n#modal-content-bottom .team-sub .days {\r\n    color: #905c5c;\r\n}\r\n#modal-content-bottom .team-sub .name {\r\n    color: #26a69a;\r\n}\r\n#modal-content-bottom .team-sub {\r\n    font-size: 13px;\r\n}\r\n#modal-content-bottom .title {\r\n    font-weight: 600;\r\n}\r\n#modal-content-bottom {\r\n    padding: 0px;\r\n    border-top: 2px dashed #ddd;\r\n    padding-top: 15px;\r\n}\r\n#btn-cancel {\r\n    float: right;\r\n    margin-left: 12px;\r\n    color: red;\r\n    font-size: 14px;\r\n    text-transform: none;\r\n    height: 33px;\r\n    line-height: 32px;\r\n    border-radius: 16px;\r\n    width: 90px;\r\n}\r\n#btn-approve {\r\n    float: right;\r\n    font-size: 14px;\r\n    text-transform: none;\r\n    height: 33px;\r\n    line-height: 32px;\r\n    border-radius: 16px;\r\n    width: 90px;\r\n    background-color: #2ec6b7;\r\n}\r\n#modal-content-right .modal-error-text {\r\n    height: auto;\r\n    line-height: normal;\r\n    font-size: 14px;\r\n    margin-bottom: 10px;\r\n    font-weight: normal;\r\n}\r\n#modal-content-right #content-right-btn {\r\n    padding: 0px;\r\n}\r\n#modal-content-right textarea.materialize-textarea:focus:not([readonly]) {\r\n    box-shadow: 0 0px 0 0 #26a69a;\r\n}\r\n#modal-content-right textarea.materialize-textarea {\r\n    box-shadow: 0 0px 0 0 #26a69a;\r\n    color: #905c5c;\r\n}\r\n#modal-content-right .input-field {\r\n    padding: 10px 0px;\r\n    padding-bottom: 0px;\r\n}\r\n#modal-content-right .helper-text {\r\n    display: none;\r\n}\r\n#modal-content-right #inp-req-note {\r\n    font-size: 14px;\r\n    border: 2px solid #aaa4a4;\r\n    padding: 8px 10px;\r\n    min-height: 120px;\r\n    max-height: 120px;\r\n    overflow: auto;\r\n}\r\n#modal-content-right .textcolor {\r\n    color: #000;\r\n}\r\n#modal-content-right #sub-box-balance .textcolor {\r\n    color: #728431 !important;\r\n}\r\n#modal-content-right .text-hour {\r\n    display: block;\r\n    font-size: 11px;\r\n    margin-top: 0px;\r\n    height: 15px;\r\n}\r\n#modal-content-right .text-day {\r\n    display: block;\r\n    font-size: 18px;\r\n    font-weight: bold;\r\n}\r\n#modal-content-right .title {\r\n    display: block;\r\n    font-weight: 600;\r\n}\r\n#modal-content-right .sub-box {\r\n    padding: 12px 0;\r\n    text-align: center;\r\n    border-radius: 12px;\r\n    margin: 0;\r\n    background-color: #F2F0D5;\r\n    width: 100%;\r\n}\r\n#team-content .th-view, #team-content .th-change {\r\n    max-width: 70px;\r\n}\r\n#team-content .th-status {\r\n    max-width: 100px;\r\n    min-width: 100px;\r\n}\r\n#team-content #main-content {\r\n    padding-top: 0px;\r\n}\r\n#team-content #top-content {\r\n    border-bottom: 0px dashed #ece7e7;\r\n}\r\n#team-content #main-btn {\r\n    border-bottom: 2px dashed #ece7e7;\r\n    padding-bottom: 18px;\r\n}\r\n#table-leave-summary .text-left,\r\n.table-leave .text-left {\r\n    text-align: left;\r\n}\r\n#team-content .td-photo {\r\n    height: 65px;\r\n    position: relative;\r\n    min-width: 56px;\r\n}\r\n#team-content .image-circle {\r\n    width: 56px;\r\n    height: 56px;\r\n    position: absolute;\r\n    top: 4px;\r\n    left: 50%;\r\n    margin-left: -28px;\r\n}\r\n#team-content .select-helper-text {\r\n    margin-top: -10px;\r\n}\r\n#team-content #form-filter-request {\r\n    padding: 0 20px;\r\n}\r\n#btn-clear {\r\n    float: right;\r\n    color: #000;\r\n    margin-left: 15px;\r\n}\r\n#btn-search {\r\n    float: right;\r\n    background-color: #1565c0;\r\n}\r\n#team-content #btn-select-limit-row .input-field {\r\n    margin-bottom: 0px;\r\n}\r\n#team-content .input-field {\r\n    margin-top: 0px;\r\n    margin-bottom: 1rem;\r\n}\r\n#team-content .select-wrapper .caret {\r\n    fill: #27766f;\r\n}\r\n#team-content .filter-input-field.select .col {\r\n    border: 2px solid #2b988e;\r\n    border-radius: 11px;\r\n}\r\n#team-content .dropdown-content li {\r\n    min-height: auto;\r\n}\r\n#team-content .dropdown-content li>a, #team-content .dropdown-content li>span {\r\n    line-height: 20px;\r\n    padding: 10px 16px;\r\n}\r\n#team-content .input-field>label, #team-content .input-field>input[type=date]:not(.browser-default)+label {\r\n    color: #27766f;\r\n}\r\n#team-content input[type=text]:not(.browser-default), #team-content input[type=date]:not(.browser-default) {\r\n    font-size: 14px;\r\n    border-bottom: 2px solid #2b988e !important;\r\n    color: #26a69a;\r\n}\r\n#team-content [type=\"checkbox\"]+span:not(.lever) {\r\n    height: 22px;\r\n    line-height: 22px;\r\n    font-size: 14px;\r\n}\r\n#team-content .select-wrapper input.select-dropdown {\r\n    font-size: 14px;\r\n    border-bottom: 0px solid red !important;\r\n    margin-bottom: 0px;\r\n    color: #26a69a;\r\n}\r\n#team-content .grid-container, #team-content .filter-inputs {\r\n    display: grid;\r\n    grid-template-columns: auto auto auto auto auto;\r\n    grid-gap: 10px;\r\n}\r\n\r\n/* --- PILL TABS (manual buttons) --- */\r\n.pill-tabs { display:flex; gap:12px; align-items:center; }\r\n.pill-tab {\r\n  appearance: none;\r\n  border: 0;\r\n  background: transparent;\r\n  padding: 12px 24px;          /* ↑ ขยายให้ใหญ่ขึ้น */\r\n  border-radius: 6px;\r\n  font-weight: 600;\r\n  font-size: 16px;             /* ↑ ปรับขนาดฟอนต์ */\r\n  color: #111;\r\n  cursor: pointer;\r\n  line-height: 1.1;\r\n}\r\n.pill-tab:hover { background: #f6f6f6; }\r\n.pill-tab:focus { outline: none; box-shadow: 0 0 0 2px rgba(0,0,0,.05); }\r\n.pill-tab.active {\r\n  background: #efefef;         /* เทาอ่อนตอน active */\r\n  color: #111;\r\n  font-weight: 700;\r\n}\r\n@media (max-width: 480px) {\r\n  .pill-tab { font-size: 16px; padding: 10px 18px; border-radius: 10px; }\r\n}\r\n\r\n/* แถวหัว: Tabs + ปุ่มด้านขวา ให้อยู่บรรทัดเดียว */\r\n.tabs-actions-row {\r\n  display:flex; align-items:center; justify-content:space-between;\r\n  gap:16px; flex-wrap:wrap; margin-bottom:15px;\r\n}\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
